import { render, staticRenderFns } from "./Jigsaw.vue?vue&type=template&id=03570a67"
import script from "./Jigsaw.vue?vue&type=script&lang=js"
export * from "./Jigsaw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports